module.exports = __webpack_public_path__ + "static/media/activity-feed-item-entry-userflow-new.2ecf3fa7.jpg";